/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import 'reflect-metadata';
import './polyfills';

// install modernizr tests
import { customModernizrTests } from './app/modernizr.custom';

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import { DashGisModule } from './app/dash-gis.module';
import { env } from './environments/environment-factory';

customModernizrTests();

// videojs
(window as any).VIDEOJS_NO_DYNAMIC_STYLE = true;

if (env.production) {
    enableProdMode();
} else {

    /*
     * In development mode, to ignore zone related error stack frames such as
     * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
     * import the following file, but please comment it out in production mode
     * because it will have performance impact when throw error
     */
    require('zone.js/dist/zone-error');  // Included with Angular CLI.

}

platformBrowserDynamic().bootstrapModule(DashGisModule).catch((err) => {
    console.error(err);
});
